import { render } from "./DemosView.vue?vue&type=template&id=66915acb&scoped=true"
import script from "./DemosView.vue?vue&type=script&lang=js"
export * from "./DemosView.vue?vue&type=script&lang=js"

import "./DemosView.vue?vue&type=style&index=0&id=66915acb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66915acb"]])

export default __exports__